import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import EmailWhiteListEdit   from "./EmailWhiteListEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Email White List
 * @returns {React.ReactElement}
 */
function EmailWhiteList() {
    const { fetch, load } = useList("emailWhiteList");

    const data = Store.useState("emailWhiteList");
    const { loading, canEdit, list, total, sort } = data;

    const { removeEmail } = Store.useAction("emailWhiteList");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await removeEmail(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "emailID", elemID, "email");

    return <Main>
        <Header message="EMAIL_WHITE_LIST_NAME" icon="white-email">
            <ActionList data={data} onAction={startAction} useAdd />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="EMAIL_WHITE_LIST_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="email"       message="GENERAL_EMAIL"       isTitle />
                    <TableHeader field="description" message="GENERAL_DESCRIPTION" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.emailID} elemID={elem.emailID}>
                        <TableCell message={elem.email}       />
                        <TableCell message={elem.description} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="EMAIL_WHITE_LIST_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="EMAIL_WHITE_LIST_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <EmailWhiteListEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="EMAIL_WHITE_LIST_DELETE_TITLE"
            message="EMAIL_WHITE_LIST_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default EmailWhiteList;
